/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Dashboard_Detail_Usage_GrossInputs */



/**
* | output |
* | --- |
* | "AI usage (gross)" |
*
* @param {Partner_Dashboard_Detail_Usage_GrossInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_dashboard_detail_usage_gross = /** @type {((inputs?: Partner_Dashboard_Detail_Usage_GrossInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Dashboard_Detail_Usage_GrossInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("KI-Nutzung (brutto)")
	return /** @type {LocalizedString} */ ("AI usage (gross)")
});